<div class="main-div">
    <div class="col-12  flex flex-wrap">
        <h2>شیرینی حاج خلیفه</h2>
        <div class="col-12">
            <p>
                طعم لطیف و عطر دل‌انگیز شیرینی یزد، همچون یادگاری از گذشته‌های دور است که هر لقمه‌اش، خاطراتی شیرین و دلنشین را زنده می‌کند. این شیرینی نه تنها یک خوراکی خوشمزه، بلکه پیوندی است میان نسل‌ها و نمادی از همبستگی و شادی در آغاز سال نو. برایتان شادی، تندرستی و کام شیرین آرزو داریم.
            </p>
        </div>
        <div class="col-12 flex flex-wrap imgs">
          <div class="col-5">

              <img  src="{{conf.getBaseUrl()+'lnd/file/get_image?name=shirini4.jpeg' }}">
          </div>
          <div class="col-7">
              <img  src="{{conf.getBaseUrl()+'lnd/file/get_image?name=shirini3.jpeg' }}">
          </div>
          <div class="col-7">
              <img  src="{{conf.getBaseUrl()+'lnd/file/get_image?name=shirini2.jpg' }}">
          </div>
          <div class="col-5">
              <img  src="{{conf.getBaseUrl()+'lnd/file/get_image?name=shirini1.jpg' }}">
          </div>
        </div>
    </div>
</div>